import { Component, Input } from '@angular/core';
import { ListItem } from '@app/shared/components/rc-list/list-item';
import { DataCSmaskDirective } from '../../directives/data-cs-mask.directive';
import { SafeHtmlPipe } from '@app/shared/pipes';

@Component({
  selector: 'app-rc-list',
  templateUrl: './rc-list.component.html',
  styleUrls: ['./rc-list.component.scss'],
  imports: [DataCSmaskDirective, SafeHtmlPipe],
})
export class RcListComponent {
  @Input() highlightValue = false;
  @Input() listItems: ListItem[];
}
